import request from "../../../helpers/request";

interface IRequestGetRptDispositivos {
  idLoja: string;
  reportType: string;
}

export const getRptDispositivos = async ({idLoja, reportType}: IRequestGetRptDispositivos) => {
  if (!idLoja) return null;
  const url = `${process.env.REACT_APP_API}/Relatorio/RptDispositivos/${idLoja}?reportType=${reportType}`;
  const result = await request({ url, responseType: "blob" });
  return result;
};
